





















































import {Component, Mixins} from 'vue-property-decorator';
import CustomPropertySummary from '@/components/product/customProperty/CustomPropertySummary.vue';
import CustomPropertySlotRight from '@/components/product/customProperty/CustomPropertySlotRight.vue';
import CustomPropertyMethodsMixin from '@/components/product/customProperty/CustomPropertyMethodsMixin';
import CustomPropertyBottomContent from '@/components/product/customProperty/CustomPropertyBottomContent.vue';
import PageTitle from '@/components/common/PageTitle.vue';
import PageSizeData from '@/components/product/customProperty/PageSizeData';
import PageFormSelect from '@/components/product/customProperty/PageFormSelect.vue';
import {addClass} from '@/utils/classUtils';

@Component({
  components: {
    CustomPropertySummary,
    CustomPropertyBottomContent,
    CustomPropertySlotRight,
    PageTitle,
    PageSizeData,
    PageFormSelect
  }
})
export default class PopupCustomProperty extends Mixins(CustomPropertyMethodsMixin, PageSizeData) {
  public mounted() {
    addClass(document.body, 'popup');
  }
}
